export const getMaxQuantitaOrdinabileLeadTime = (leadTimePersonalizzazioni, byTecnica = null) => {
  const allLeadTimePersonalizzazioni =
    leadTimePersonalizzazioni?.tecniche
      ?.filter((tecnica) => (!!byTecnica ? tecnica.id === byTecnica : true))
      .flatMap((tecnica) =>
        tecnica.posizioni.flatMap((posizione) =>
          posizione.numero_colori.flatMap((numeroColore) => numeroColore.personalizzazioni_objects)
        )
      ) || []

  const validLeadTimePersonalizzazioni = allLeadTimePersonalizzazioni.filter(
    (p) => p?.leadtime?.max_quantita_ordinabile
  )

  if (!validLeadTimePersonalizzazioni?.length) {
    return null
  }

  const highestQuantitaLeadTime = validLeadTimePersonalizzazioni.reduce((best, current) => {
    return current.leadtime.max_quantita_ordinabile < best.leadtime.max_quantita_ordinabile
      ? current
      : best
  })

  return highestQuantitaLeadTime?.leadtime
}

export const isQuantitaValidLeadTime = (leadTimePersonalizzazioni) => {
  if (
    leadTimePersonalizzazioni?.tecniche?.every(
      (t) =>
        !t?.posizioni?.[0]?.numero_colori?.[0]?.personalizzazioni_objects?.[0]?.leadtime?.fornitore
    )
  ) {
    return false
  }

  return true
}
